/* eslint-disable no-param-reassign,@typescript-eslint/no-unused-vars,@typescript-eslint/no-use-before-define, no-useless-concat */

xplenty.directive('cloudStorageDestinationEditor', [
  '$translate',
  '$compile',
  function ($translate, $compile) {
    return {
      restrict: 'E',

      // eslint-disable-next-line global-require
      template: require('./cloud-storage-destination-editor.html'),

      replace: true,

      link(scope, element, attrs) {},

      controller: [
        '$scope',
        'ComponentEditorListeners',
        function ($scope, ComponentEditorListeners) {
          $scope.hasContainer = false;
          $scope.hasBucket = true;
          $scope.hasPreProcess = true;
          $scope.errors = [];

          $scope.destinationTypes = [
            {
              name: $translate.instant('cloud-storage-destination-editor.selects.format.csv_destination_type'),
              value: 'csv_destination_type',
              active: false,
              data: {
                csv_destination_type: {
                  field_delimiter: '\\t',
                  text_qualifier: '',
                  write_header: false,
                  line_ending: 'unix', // has no effect on initial value in UI
                },
              },
            },
            {
              name: $translate.instant('cloud-storage-destination-editor.selects.format.json_destination_type'),
              value: 'json_destination_type',
              active: false,
              data: {
                json_destination_type: {
                  json_destination_type: true,
                },
              },
            },
            {
              name: $translate.instant('cloud-storage-destination-editor.selects.format.parquet_destination_type'),
              value: 'parquet_destination_type',
              active: false,
              data: {
                parquet_destination_type: {
                  parquet_destination_type: true,
                },
              },
            },
          ];

          $scope.operationTypes = [
            {
              value: 'fail_if_exists',
              text: 'cloud-storage-destination-editor.selects.directory_exists_actions.fail_if_exists',
              translate: true,
            },
            {
              value: 'delete_destination_path',
              text: 'cloud-storage-destination-editor.selects.directory_exists_actions.delete_destination_path',
              translate: true,
            },
            {
              value: 'replace_existing_files',
              text: 'cloud-storage-destination-editor.selects.directory_exists_actions.replace_existing_files',
              translate: true,
              tooltip: 'cloud-storage-destination-editor.hints.replace_existing_files',
              translateTooltip: true,
            },
            {
              value: 'copy_files',
              text: 'cloud-storage-destination-editor.selects.directory_exists_actions.copy_files',
              translate: true,
              tooltip: 'cloud-storage-destination-editor.hints.directory_exists',
              translateTooltip: true,
            },
          ];

          $scope.charEncodings = [
            {
              value: 'utf-8',
              text: 'cloud-storage-source-editor.form.selects.char_encoding.options.utf_8',
              translate: true,
            },
            {
              value: 'utf-16',
              text: 'cloud-storage-source-editor.form.selects.char_encoding.options.utf_16',
              translate: true,
            },
            {
              value: 'shift-jis',
              text: 'cloud-storage-source-editor.form.selects.char_encoding.options.shift_jis',
              translate: true,
            },
            {
              value: 'cp932',
              text: 'cloud-storage-source-editor.form.selects.char_encoding.options.cp932',
              translate: true,
            },
          ];

          $scope.selectDestinationType = function (destinationTypeValue, data) {
            _.each($scope.destinationTypes, function (destinationType) {
              if (destinationTypeValue === destinationType.value) {
                destinationType.active = true;
                if (data && data.csv_destination_type && data.csv_destination_type.text_qualifier === '') {
                  data.csv_destination_type.text_qualifier = 'none';
                }
                if (data) destinationType.data = data;
                $scope.component.destination_type = destinationType.data;
                if (destinationTypeValue === 'parquet_destination_type') {
                  $scope.component.compression_type = 'none';
                  $scope.component.line_ending = 'unix';
                }
              } else {
                destinationType.active = false;
              }
            });
          };

          $scope.onDestinationActionChange = function (value) {
            $scope.component.operation_type = value;
            const deprecatedTypes = $scope.operationTypes.filter((type) => type.deprecated).map((type) => type.value);

            if (deprecatedTypes.includes(value)) {
              addOperationTypeError();
            } else {
              $scope.errors.pop();
            }
          };

          $scope.onCharEncodingChange = function (charEncoding) {
            $scope.component.char_encoding = charEncoding;
          };

          function addOperationTypeError() {
            const suggestedOption = $scope.operationTypes.find((type) => type.value === 'copy_files');

            $translate('cloud-storage-destination-editor.form.errors.replace_existing_files', {
              suggested_option: suggestedOption.text,
            }).then((error) => {
              $scope.errors.push(error);
            });
          }

          $scope.removeError = function (error) {
            const removeIndex = $scope.errors.indexOf(error);
            $scope.errors.splice(removeIndex, 1);
          };

          const keys = Object.keys($scope.component.destination_type);

          if (keys.length === 1) $scope.selectDestinationType(keys[0], $scope.component.destination_type);

          $scope.$watch(
            'component.connection',
            function (connection) {
              if (connection || connection.type) {
                switch (connection.type) {
                  case 'sftp':
                  case 'ftps':
                  case 'hdfs':
                    $scope.hasContainer = false;
                    $scope.hasBucket = false;
                    $scope.hasPreProcess = false;
                    break;
                  case 's3':
                    $scope.hasContainer = false;
                    $scope.hasBucket = true;
                    $scope.hasPreProcess = true;
                    break;
                  case 'gs':
                    $scope.hasContainer = false;
                    $scope.hasBucket = true;
                    $scope.hasPreProcess = false;
                    break;
                  case 'azureblobstorage':
                    $scope.hasContainer = true;
                    $scope.hasBucket = false;
                    $scope.hasPreProcess = false;
                    break;
                  default:
                    $scope.hasContainer = false;
                    $scope.hasBucket = false;
                    $scope.hasPreProcess = false;
                    break;
                }
              }
            },
            true,
          );

          if ($scope.component.delete_destination_path) {
            $scope.component.operation_type = 'delete_destination_path';
          } else if ($scope.component.destination_exists_action === 'fail_if_exists') {
            $scope.component.operation_type = 'fail_if_exists';
          } else if ($scope.component.destination_exists_action === 'replace_existing_files') {
            $scope.component.operation_type = 'replace_existing_files';
          } else if ($scope.component.destination_exists_action === 'copy_files') {
            $scope.component.operation_type = 'copy_files';
          }

          const onSaveSuccessCallback = function () {
            if ($scope.component.operation_type === 'fail_if_exists') {
              $scope.component.delete_destination_path = false;
              $scope.component.destination_exists_action = 'fail_if_exists';
            } else if ($scope.component.operation_type === 'delete_destination_path') {
              $scope.component.delete_destination_path = true;
              $scope.component.destination_exists_action = 'fail_if_exists';
            } else if ($scope.component.operation_type === 'replace_existing_files') {
              $scope.component.delete_destination_path = false;
              $scope.component.destination_exists_action = 'replace_existing_files';
            } else if ($scope.component.operation_type === 'copy_files') {
              $scope.component.delete_destination_path = false;
              $scope.component.destination_exists_action = 'copy_files';
            }
          };
          ComponentEditorListeners.onSaveSuccess(onSaveSuccessCallback);

          $scope.$on('$destroy', function () {
            ComponentEditorListeners.clearOnSaveSuccessCb(onSaveSuccessCallback);
          });
        },
      ],
    };
  },
]);
